import { gql } from '@lcs/shared/api';

export const getBlockedPhoneNumberQuery = gql`
   query GetBlockedPhoneNumberRegister(
      $first: Int!
      $filters: String
      $after: String
      $orderingOptions: [OrderingOption!]
   ) {
      blockedPhoneNumbersConnection(
         first: $first
         filters: $filters
         after: $after
         orderingOptions: $orderingOptions
      ) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            blockedPhoneNumberId
            phoneNumber
            comment
         }
      }
   }
`;
